import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import AnnotatorSidebar from '../components/AnnotatorSidebar';
import ErrorBoundary from '../components/ErrorBoundary';
import Footer from '../components/Footer';

export default function AnnotatorLayout() {
  // Match admin: dark-editorial brand theme. Annotators see the same
  // warm-ink surface as the landing + login, so the marketplace experience
  // feels like one continuous voice from first-click through working.
  // No cleanup-restore: prev/cleanup pattern leaks theme on sibling-route
  // transitions. Each layout sets its theme on mount; next mount overrides.
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'admin-dark');
  }, []);

  return (
    <div className="app">
      {/* Phase 14.7 — skip-link for keyboard-only users. Visually hidden
          until focused; jumps past sidebar chrome into the main content.
          Same offscreen-CSS pattern as AdminLayout + ClientPortal. */}
      <a
        href="#annotator-main-content"
        className="skip-link"
        style={{
          position: 'absolute',
          top: 8,
          left: 8,
          padding: '6px 12px',
          fontSize: 12,
          fontFamily: 'var(--font-mono)',
          color: 'var(--text-primary)',
          background: 'var(--accent-teal, #5DCAA5)',
          borderRadius: 6,
          textDecoration: 'none',
          zIndex: 10000,
          transform: 'translateY(-200%)',
          transition: 'transform 0.15s',
        }}
        onFocus={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
        onBlur={(e) => { e.currentTarget.style.transform = 'translateY(-200%)'; }}
      >
        Skip to main content
      </a>
      <AnnotatorSidebar />
      <main id="annotator-main-content" tabIndex={-1} className="main-content annotator-main" style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1 }}>
          <ErrorBoundary label="Annotator Page">
            <div className="annotator-page">
              <Outlet />
            </div>
          </ErrorBoundary>
        </div>
        {/* Phase 19.4 audit-fix (2026-04-29): global Footer per scope §6 + GDPR Article 13 */}
        <Footer variant="default" />
      </main>
    </div>
  );
}
